import FormHelpers from "../../../../helpers/FormHelpers";

const ERROR_MESSAGES = {
  requiredField: (fieldName) => `Error in (${fieldName}) field. Select/Enter a valid value then proceed.`,
};

const validateDocLevel = ({
  piNumber,
  selectedTenant,
  selectedDepartment,
  selectedTenantDepartment,
  cfPurchaseIndentDoc,
}) => {

  const errors = [];
  errors?.push({
    name: 'Purchase Indent #',
    value: String(piNumber)?.trim(),
    message: ERROR_MESSAGES.requiredField('Purchase Indent #'),
  });
  errors?.push({
    name: 'Location',
    value: selectedTenant,
    message: ERROR_MESSAGES.requiredField('Location'),
  });
  if ((!selectedDepartment || !selectedTenantDepartment)) {
    errors?.push({
      name: 'Department',
      value: 0,
      message: ERROR_MESSAGES.requiredField('Department'),
    });
  }
  if (cfPurchaseIndentDoc) {
    cfPurchaseIndentDoc?.filter((cf) => (cf?.isRequired && cf?.isActive))?.forEach((cf) => {
      errors?.push({
        name: cf?.fieldName,
        value: cf?.fieldValue,
        message: ERROR_MESSAGES.requiredField(cf?.fieldName),
      });
    });
  }

  return errors;
};

const validateLineLevel = ({
  data,
  cfPurchaseIndentLine,
}) => {

  const errors = [];
  data?.forEach((line) => {

    if (!line?.product_sku_id) {
      errors.push({
        name: 'Products',
        value: 0,
        message: 'Error in Product. Select a product to continue.',
      });
    } else {
      errors.push({
        name: 'Quantity',
        value: line?.quantity,
        message: ERROR_MESSAGES.requiredField(`Quantity in Product '${line?.internal_sku_code || ""}'`),
      });
      errors.push({
        name: 'Unit',
        value: line?.uom_id,
        message: ERROR_MESSAGES.requiredField(`Unit in Product '${line?.internal_sku_code || ""}'`),
      });
      if (cfPurchaseIndentLine) {
        line?.lineCustomFields?.filter((cf) => (cf?.fieldName !== 'Quantity' && cf?.fieldName !== 'Rate'))?.forEach((cf) => {
          if (cf?.isRequired && cf?.isActive) {
            errors?.push({
              name: cf?.fieldName,
              value: cf?.fieldValue,
              message: ERROR_MESSAGES.requiredField(`${cf?.fieldName} for Product '${line?.internal_sku_code || ""}`),
            });
          }
        })
      }
    }
  });

  return errors;
};

const purchaseIndentErrors = (params) => {

  const docLevelErrors = validateDocLevel(params);
  const lineLevelErrors = validateLineLevel(params);

  return FormHelpers.errorChecker({ docLevelErrors, lineLevelErrors });
};

export default purchaseIndentErrors;